<template>
  <div>
    <div class="row">
      <div class="col">
        <h2>Waitlist</h2>
        <div v-if="isLoading" class="loading">
          <span class="spinner-border" role="status"></span>
        </div>
        <div v-else>
          <form v-on:submit="false">
            <div class="row">
              <div class="col-md-8">
                <input type="text" name="search" id="search" class="form-control" placeholder="Search by name" v-model="filterSearch" />
              </div>
              <div class="col-md-4">
                <select name="floorplan" id="floorplan" class="form-control" v-model="filterFloorplan">
                  <option value="">All Floorplans</option>
                  <option v-for="i in floorplans" v-bind:key="i">{{ i }}</option>
                </select>
              </div>
            </div>
          </form>
          <div class="tabs">
            <ul>
              <li v-for="thisFilter in filters" v-bind:key="thisFilter.value">
                <button :class="['btn', { active: activeFilter == thisFilter.value }]" v-on:click="setFilter(thisFilter.value)">
                  {{ thisFilter.label }}
                </button>
              </li>
            </ul>
          </div>
          <div class="row">
            <div class="col-12 no-results" v-if="waitlist.length == 0 && rawWaitlist.length != 0">
              <p>No results found. Please try different filters.</p>
            </div>
            <div class="col-12 empty" v-if="waitlist.length == 0 && rawWaitlist.length == 0">
              <img src="../assets/icons/waitlist.svg" alt="" />
              <h3>The waitlist is currently empty</h3>
              <p>When there is a signup to be on the waitlist it will show up here on the dashboard.</p>
            </div>
            <WaitlistItem v-for="single in waitlist" v-bind:key="single.id" :waitlist="single" :statuses="statuses" :openNotes="openNotes" />
          </div>
        </div>
      </div>
    </div>
    <WaitlistNotes :open="waitlistNotesId != null" :close="closeNotes" :waitlistId="waitlistNotesId" />
  </div>
</template>

<script>
// import axios from "axios";
import { mapState } from "vuex";
import WaitlistItem from "../components/WaitlistItem.vue";
import WaitlistNotes from "../components/WaitlistNotes.vue";

export default {
  name: 'Waitlist',
  data: function () {
    let statuses = [
      {
        value: "no_contact",
        label: "No Contact"
      },
      {
        value: "contacted",
        label: "Contacted"
      },
      {
        value: "in_progress",
        label: "In Progress"
      }
    ];

    return {
      floorplans: [1,2,3,4,5,6,7,8,9,10],
      filterFloorplan: "",
      filterSearch: "",
      filters: [{value: "", label: "All Status"}, ...statuses.slice().reverse()],
      activeFilter: "",
      statuses: statuses,
      waitlistNotesId: null,
    };
  },
  computed: {
    waitlist: function () {
      let waitlist = this.rawWaitlist;

      if (this.filterSearch.trim() != "") {
        waitlist = waitlist.filter(single => single.name.toLowerCase().indexOf(this.filterSearch.toLowerCase()) >= 0);
      }

      if (this.filterFloorplan != "") {
        waitlist = waitlist.filter(single => single.floorplans.indexOf(this.filterFloorplan) >= 0);
      }

      if (this.activeFilter != "") {
        waitlist = waitlist.filter(single => single.status == this.activeFilter);
      }

      return waitlist;
    },
    ...mapState('waitlist', {
      isLoading: 'isLoading',
      rawWaitlist: 'rawWaitlist',
    })
  },
  mounted: function () {
    this.$store.dispatch('waitlist/getWaitlist');
    if (this.$route.params.waitlistId) {
      this.waitlistNotesId = this.$route.params.waitlistId;
    }
  },
  methods: {
    setFilter: function (filter) {
      this.activeFilter = filter;
    },
    openNotes: function (id) {
      this.waitlistNotesId = id;
    },
    closeNotes: function() {
      this.waitlistNotesId = null;
    }
  },
  components: {
    WaitlistItem,
    WaitlistNotes,
  }
}
</script>

<style lang="scss" scoped>
h2 {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: calc(24/20);
  color: #4A4A4A;
  margin: 3.125rem 0 1.875rem;
}

div.loading {
  text-align: center;
  padding: 100px 0;
}

div.no-results {
  margin-top: 100px;
  margin-bottom: 100px;
  color: #4A4A4A;

  p {
    text-align: center;
    margin: 0;
    font-size: 0.875rem;
  }
}

div.empty {
  margin-top: 140px;
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: #4A4A4A;

  img {
    margin-bottom: 22px;
  }

  h3 {
    font-weight: 500;
    font-size: 1.25rem;
    line-height: calc(24/20);
    text-align: center;
    margin-bottom: 24px;
    max-width: 200px;
  }

  p {
    text-align: center;
    margin: 0;
    font-size: 0.875rem;
    max-width: 310px;
  }
}
</style>
